export default __webpack_public_path__ + "static/media/bot_copilot.01c7e7fd.gif";